import { isArtLayoutCapture } from "../../artLayout";

// Reanchor the original painting's layout on a widescreen stage. Characters keep their shape.
export const STAGE = isArtLayoutCapture ? { width: 1536, height: 1024 } : { width: 1920, height: 1080 };
export const stageX = (x: number): number => x * STAGE.width / 1536;
export const stageY = (y: number): number => y * STAGE.height / 1024;
